// components/form/FormInput.jsx
import React, { useState } from "react";
import styles from "./FormInput.module.scss";
import { ReactComponent as EyeIcon } from "../../images/SVG/Frame.svg";
import { ReactComponent as EyeSlashIcon } from "../../images/SVG/closeEye.svg";
// import { ReactComponent as EyeSlashIcon } from "../../images/SVG/.svg";
import { conditionalProp } from "../../utils/utils";

const FormInput = ({
  label,
  id,
  type = "text",
  register,
  validation = {},
  error,
  options = [],
  placeholder = "",
  required,
  disabled,
  value,
  onChange,
  onKeyDown,
  selectedRadio,
  setSelectedRadio,
  showAddPlusButton = false,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleVisbility = () => {
    setShowPassword((prev) => !prev);
  };

  const renderInput = () => {
    // const registerObj = register(id, validation);
    switch (type) {
      case "select":
        return (
          <select id={id} {...register(id, validation)} disabled={disabled}>
            <option value="">Select {label}</option>
            {options.map((opt, i) => (
              <option key={i} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        );

      case "select_2":
        const registerFields = register(id, validation);
        return (
          <select
            required
            id={id}
            {...registerFields}
            disabled={disabled}
            onChange={(e) => {
              register(id).onChange(e);
              onChange?.(e);
            }}
            className={registerFields.value === "" ? styles.placeholder : ""}
          >
            <option selected disabled hidden value="">
              Select {label}
            </option>
            {options.map((opt, i) => (
              <option key={i} value={opt.id}>
                {opt.name}
              </option>
            ))}
          </select>
        );

      case "textarea":
        return (
          <textarea
            id={id}
            {...register(id, validation)}
            placeholder={placeholder}
            rows={5}
            onKeyDown={onKeyDown}
          />
        );

      case "file":
        return (
          <input
            type="file"
            id={id}
            accept=".pdf,.docx"
            {...register(id, {
              ...validation,
              validate: {
                fileType: (fileList) => {
                  const file = fileList?.[0];
                  const validTypes = [
                    "application/pdf",
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                  ];
                  return (
                    (file && validTypes.includes(file.type)) ||
                    "Only PDF or DOCX files are allowed"
                  );
                },
              },
            })}
          />
        );

      case "radio":
        return (
          <div className={styles.radio}>
            {options.map((option, index) => (
              <label
                key={index}
                className={`${styles.radioItem} ${
                  selectedRadio === option.value ? styles.selected : ""
                }`}
                // onClick={() => setSelectedRadio(option.value)}
              >
                <input
                  type="radio"
                  // {...registerObj}
                  value={option.value}
                  checked={selectedRadio === option.value}
                  onChange={(e) => {
                    setSelectedRadio(option.value);
                    // registerObj.onChange(e);
                  }}
                />
                <span className={styles.customRadio}></span>
                <p>{option.label}</p>
              </label>
            ))}
          </div>
        );

      case "email":
        return (
          <input
            {...register(id, validation)}
            id={id}
            type={type}
            placeholder={placeholder}
            value={value}
            autoComplete="off"
            disabled={disabled}
          />
        );

      case "password":
        return (
          <div className={styles.password}>
            <input
              autoComplete="off"
              {...rest}
              type={showPassword ? "text" : "password"}
              id={id}
              placeholder={placeholder}
              {...register(id, validation)}
            />
            <button type="button" onClick={toggleVisbility}>
              {!showPassword ? (
                <EyeSlashIcon className={styles.eyeIcon} />
              ) : (
                <EyeIcon className={styles.eyeIcon} />
              )}
            </button>
          </div>
        );

      default: // text, date, etc.
        return (
          <>
            <input
              {...register(id, validation)}
              id={id}
              type={type}
              placeholder={placeholder}
              value={value}
              {...conditionalProp(onChange, { onChange })}
              onKeyDown={onKeyDown}
              autoComplete="off"
              disabled={disabled}
              {...rest}
            />
            {/* {showAddPlusButton && <button type="button" onClick={onKeyDown}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19" stroke="#AEB2E3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12 5V19" stroke="#AEB2E3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>} */}
          </>
        );
    }
  };

  return (
    <div className={styles.formField}>
      <label htmlFor={id}>
        {label} {required && <span>*</span>}
      </label>
      {renderInput()}
      {error ? (
        <p className={styles.error}>{error?.message}</p>
      ) : (
        <p className={`${styles.error} ${styles.hidden}`}> </p>
      )}
    </div>
  );
};

export default FormInput;
